import styled from '@emotion/styled';

export const Wrapper = styled.div`
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    grid-column: 1 / -1;
    margin: 0;
    padding-top: 0.75rem;
    padding-bottom: 1rem;
`;

export const BarRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    min-width: 0;
`;

export const Segments = styled.div`
    display: flex;
    gap: 4px;
    flex: 1;
    min-width: 0;
`;

export const Segment = styled.div<{ active: boolean; color: string }>`
    height: 6px;
    flex: 1;
    min-width: 0;
    border-radius: 999px;
    background: ${({ active, color }) => (active ? color : '#E5E7EB')};
    transition:
        background 0.25s ease,
        transform 0.25s ease;
`;

export const StrengthLabel = styled.span<{ color: string }>`
    font-size: 12px;
    font-weight: 600;
    color: ${({ color }) => color};
    flex-shrink: 0;
    min-width: 54px;
    text-align: right;
    white-space: nowrap;
`;

export const CriteriaList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px 14px;
    min-width: 0;

    @media (max-width: 480px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const Criterion = styled.li<{ met: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 6px;
    min-width: 0;
    font-size: 12px;
    line-height: 1.4;
    overflow-wrap: anywhere;
    color: ${({ met }) => (met ? '#15803D' : '#6B7280')};
    transition: color 0.2s ease;
`;

export const IconWrap = styled.span<{ met: boolean }>`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    font-size: 14px;
    color: ${({ met }) => (met ? '#22C55E' : '#9CA3AF')};
    transition: color 0.2s ease;
`;
